import type { ReactNode } from 'react';
import { cn } from '../lib/utils';

type Props = {
  children: ReactNode;
  className?: string;
};

export const PageContent = ({ children, className }: Props) => {
  return (
    <div
      data-slot="page-content"
      // `scrollbar-tame` (defined in `src/styles.css`) ties the scrollbar
      // thumb to `--color-primary-20` and slims it to ~6 px — same recipe
      // documented in `cami-design`'s spacing-layout reference. Applied
      // at the DS primitive level so every page that uses `PageContent`
      // gets a consistent inset scrollbar instead of the chunky OS default.
      className={cn('flex flex-1 flex-col overflow-y-auto scrollbar-tame', className)}
    >
      {children}
    </div>
  );
};
